import { debounce } from 'lodash'
import i18n from 'vue-i18n'
import { Location } from "vue-router";

import { errorNotificationWrapper } from '../../../../logic/helpers/NotificationService'
import { SelectOptionData } from '../../../Pi/types'
import {
  UserSendMessageExtraItems,
} from '../UserSendMessage/types'
import { User } from './types'

export default abstract class BotUsersCore {
  isLoading = false

  page = 1
  pageSize = 10

  users: Array<User> = []
  usersCount = 0

  abstract labelsList: Array<SelectOptionData>

  protected $i18n: i18n

  private _filter = ''

  private doSearch = debounce(this.startSearch, 700)

  /** Поле строки для поиска :string */
  get filter(): string {
    return this._filter
  }

  set filter(value: string) {
    this._filter = value

    this.doSearch()
  }

  private _labels: Array<number> = []

  /** Поле ярлыков для поиска :Array<number> */
  get labels(): Array<number> {
    return this._labels
  }

  set labels(value: Array<number>) {
    this._labels = value
    this.doSearch()
  }

  protected constructor(i18n: i18n) {
    this.$i18n = i18n
  }

  init(): void {
    this.isLoading = true

    this.debouncedGetUsers({ offset: 0, limit: this.pageSize })
  }

  pageSizeChanger({ current, pageSize }: { current: number, pageSize: number }): void {
    let offset = 0

    if (pageSize === this.pageSize) {
      this.page = current
      offset = (current - 1) * pageSize
    } else {
      this.page = current === 1 ? 1 : Math.ceil(this.page * this.pageSize / pageSize)
      offset = this.page === 1 ? 0 : this.page * pageSize
    }
    this.pageSize = pageSize

    this.isLoading = true

    const requestBody = {
      offset,
      limit: pageSize,
      ...this.filter.trim().length ? { filter: this.filter } : {},
      ...this.labels.length ? { labels: this.labels } : {}
    }

    this.debouncedGetUsers(requestBody)
  }

  startSearch(): void {
    this.page = 1
    this.isLoading = true

    const requestBody = {
      offset: 0,
      limit: this.pageSize,
      ...this.filter.trim().length ? { filter: this.filter } : {},
      ...this.labels.length ? { labels: this.labels } : {}
    }

    this.debouncedGetUsers(requestBody)
  }

  private debouncedGetUsers = debounce((requestBody: {
    offset: number,
    limit: number,
    filter?: string,
    labels?: Array<number>
  }) => {
    //isLoading flag goes true in places where this fn calls to prevent delay on it
    this.getUsers(requestBody)
      .then(({ items, count }) => {
        this.users = items
        this.usersCount = count
      })
      .finally(() => {
        this.isLoading = false
      })
  }, 800)

  abstract getUsers(params: {
    offset: number,
    limit: number,
    filter?: string,
    labels?: Array<number>
  }): Promise<{ items: Array<User>, count: number }>
  abstract getLabel(id: number): string
  abstract toProfile(id: number): Location

  abstract userSendMessage(id: number, login: string, state: User['state']): ReturnType<UserSendMessageExtraItems>
}
